import React, { useContext, useEffect } from 'react';
import { UserContext } from '../contexts/UserContext';
import { Navigate } from 'react-router-dom';
import { checkTokenAndLogout } from '../utils/auth';
import { checkAccess, resolveAllowedPermissions } from '../utils/permissionConfig';

export default function ProtectedRoute({
  allowedLevels = [],
  allowedUsers = [],
  allowedPermissions = [],
  children
}) {
  const { userInfo, isUserLoading } = useContext(UserContext);

  // ProtectedRoute에서도 토큰 검사
  useEffect(() => {
    if (!isUserLoading && checkTokenAndLogout()) {
      return; // 토큰이 만료되었으면 자동 로그아웃 처리됨
    }
  }, [isUserLoading]);

  if (isUserLoading) return null;
  if (!userInfo) return <Navigate to="/login" replace />;

  const resolvedAllowedPermissions = resolveAllowedPermissions(allowedPermissions, allowedUsers);

  // 중앙 설정으로 권한 체크
  if (!checkAccess(userInfo, allowedLevels, resolvedAllowedPermissions)) {
    return <p>접근불가능페이지입니다.</p>;
  }
  return children;
}
